module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("所在出版单位(非部门)"), _c('br'), _vm._v("具有的出版资质包括：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("主营出版业务"), _c('br'), _vm._v("(营收高于音像电子业务的出版业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.mainBusinessTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessTs", $$v)
      },
      expression: "params.mainBusinessTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.mainBusinessQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessQk", $$v)
      },
      expression: "params.mainBusinessQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.mainBusinessWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessWl", $$v)
      },
      expression: "params.mainBusinessWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.mainBusinessBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessBz", $$v)
      },
      expression: "params.mainBusinessBz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.mainBusinessRm1),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessRm1", $$v)
      },
      expression: "params.mainBusinessRm1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("是否主营有其他业务"), _c('br'), _vm._v("（营收高于出版业务的业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "连续型电子/网络出版物"
    },
    model: {
      value: (_vm.params.expandBusinessLxdz),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessLxdz", $$v)
      },
      expression: "params.expandBusinessLxdz"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "无",
      "disabled": "",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("的单位或部门"), _c('br'), _vm._v("结合"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务"), _c('br'), _vm._v("开设并运营有以下项目：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWebNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWebNum", $$v)
      },
      expression: "params.operationProjectWebNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectDatabaseNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabaseNum", $$v)
      },
      expression: "params.operationProjectDatabaseNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum1),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum1", $$v)
      },
      expression: "params.operationProjectWechatNum1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('span', {
    staticClass: "chboxLeft"
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum2),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum2", $$v)
      },
      expression: "params.operationProjectWechatNum2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（总用户数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectAppNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectAppNum", $$v)
      },
      expression: "params.operationProjectAppNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（小程序用户数或APP下载量）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "粉丝数"
    },
    model: {
      value: (_vm.params.operationProjectWeiboNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeiboNum", $$v)
      },
      expression: "params.operationProjectWeiboNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（粉丝数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他（与第三方平台合作)"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "平台数量"
    },
    model: {
      value: (_vm.params.operationProjectOtherNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherNum", $$v)
      },
      expression: "params.operationProjectOtherNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版单位(社)领导：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbSld", $$v)
      },
      expression: "params.zbSld"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("编辑人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbBjry", $$v)
      },
      expression: "params.zbBjry"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等相关人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("中除编辑以外"), _c('br'), _vm._v("的有关新媒体、网络运营等技术人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumInternation),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumInternation", $$v)
      },
      expression: "params.pepnumInternation"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("的专职"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版物发行人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  }), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-9：出版经营情况调查表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5dacef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table209.vue
// module id = 1721
// module chunks = 1